import { TextBlockLayout } from '@modules/VanOord.CMS/Frontend/cmsPage/blocks/block/textBlock/textBlock.layout'
import { Img } from '@shared/Frontend/components/img'
import { translate } from '@shared/Frontend/utils/translate'
import { PublicSiteState } from 'EntryPoint/Frontend/root/state'
import * as i18next from 'i18next'
import * as React from 'react'
import { fromJSX, IOWidget } from 'widgets-for-react'
import { MainLayout } from '../../../../../main/main.layout'
import { inert } from '../application.mod'
import { loaderFull } from './loader.mod'

export const notfound_page: IOWidget<PublicSiteState, never> = (public_state: PublicSiteState) =>
  public_state?.serverRedirectState != null &&
  (public_state.serverRedirectState.redirect.kind == 'loading' ||
    (public_state.serverRedirectState.redirect.kind == 'loaded' &&
      public_state.serverRedirectState.redirect.value.kind == 'r') ||
    (public_state.serverRedirectState.redirect.kind == 'loaded' &&
      public_state.serverRedirectState.redirect.value.kind == 'l'))
    ? loaderFull
    : fromJSX(() => (
        <MainLayout className="main main--error main--page" inert={inert(public_state)}>
          <article className="page">
            <header className="hero hero--generic">
              <div className="hero__inner ls-container">
                <div className="hero__content">
                  <div className="hero__header">
                    <span className="hero__label">
                      {/* TO DO: add content type */}
                      404
                    </span>
                    <h1 className="hero__title title--m">{i18next.t('Common:404:Title')}</h1>
                  </div>
                </div>
                <div className="hero__visual">
                  <Img
                    loading="eager"
                    fetchpriority="high"
                    className="pageheader__image"
                    alt=""
                    width="1360"
                    height="680"
                    crops={[
                      { url: '/frontend/images/404-en-header-680w.jpg', width: 680 },
                      { url: '/frontend/images/404-en-header-1360w.jpg', width: 1360 }
                    ]}
                  />
                </div>
              </div>
            </header>
            <div className="page__content">
              <TextBlockLayout id="error-page-text" text={translate('Common:404:Return')} />
            </div>
          </article>
        </MainLayout>
      ))
